function Bridge(app) {
	this.p = app;

	$(window).on('storage', $.proxy(this.storageUpdated, this));
}

Bridge.prototype.storageUpdated = function (event) {

	// newly value set in localStorage, here do what you want with it
	if (this.p.type == "wall") {
		// we can create a new WallVideo here
		if (event.originalEvent.key == localStorageName) {
			var num = parseInt(localStorage.getItem(localStorageName));
			console.log("wall new video added -> " + num);
			this.p.wall.addVideo(num);
		} else if (event.originalEvent.key == 'reset-wall') {
			localStorage.removeItem('reset-wall');
			this.p.wall.reset();
		}
	}
}

// Expose App
window.Bridge = Bridge;